import  { useState } from "react";
import { bookHeaders } from "../../components/Data/datas";
import Overview from "./Overview";
import Curriculum from "./Curriculum";
import Instructor from "./Instructor";
import ReviewOnCourse from "./ReviewOnCourse";
import AReply from "./AReply";
import ImgCourseProg from "./ImgCourseProg";

const MainContent = ({ lessonNumber, bookImage, ratings, curriculumId }) => {
  let [toggle, setToggle] = useState("Overview");

  function handleToggle(whcHandler) {
    setToggle(whcHandler);
  }

  return (
    <div className="grid sm:grid-cols-[1fr_auto] py-20 sm:px-10 px-5">
      <div>
        <div className="sm:flex  grid grid-cols-2 bg-[#eaebf0]">
          {bookHeaders.map((header, i) => (
            <div
              key={i}
              onClick={() => handleToggle(header)}
              className={`cursor-po[Inter] p-5 px-10 sm:px-16 text-center ${
                toggle == header &&
                " bg-white  border-t-2 text-[#004C97] border-[#66B2FF]"
              }`}
            >
              <p>{header}</p>
            </div>
          ))}
        </div>
        <div className="py-10">
          {toggle === bookHeaders[0] ? (
            <Overview />
          ) : toggle === bookHeaders[1] ? (
            <Curriculum curriculumId={curriculumId} />
          ) : toggle === bookHeaders[2] ? (
            <Instructor />
          ) : (
            <ReviewOnCourse ratings={ratings} />
          )}
        </div>
        <AReply />
        <ImgCourseProg lessonNumber={lessonNumber} bookImage={bookImage} />
      </div>
      <div className="w-80"></div>
    </div>
  );
};

export default MainContent;
